import React from 'react';
import { Calendar, CheckCircle2, Download, Video, XCircle } from 'lucide-react';
import { fmtDate, fmtTime, tzLabel } from '../../lib/timezone';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BookingShell = ({ children }) => (
  <div className="min-h-screen bg-[#f4f1ea] py-10 px-4" data-testid="booking-shell">
    <div className="max-w-4xl mx-auto">
      <p className="text-xs uppercase tracking-[0.2em] text-[#1a3a5c]/70 mb-3 font-semibold">Elite Home Rehab</p>
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 md:p-8">{children}</div>
    </div>
  </div>
);

export const BookingSummary = ({ booking, tz, heading, children, manage = false }) => {
  const cancelled = booking.status === 'cancelled';
  const Icon = cancelled ? XCircle : CheckCircle2;
  return (
    <div className="max-w-lg mx-auto text-center space-y-4" data-testid="booking-summary">
      <Icon size={44} className={`mx-auto ${cancelled ? 'text-slate-400' : 'text-emerald-600'}`} />
      <h1 className="text-2xl font-semibold" data-testid="booking-summary-heading">{heading}</h1>
      <p className="text-slate-600">{booking.title}</p>
      <div className="rounded-lg bg-slate-50 border p-4 text-left text-sm space-y-2">
        <p className="flex items-start gap-2" data-testid="booking-summary-when">
          <Calendar size={15} className="mt-0.5" />
          <span>{fmtDate(booking.starts_at, tz)}<br />{fmtTime(booking.starts_at, tz)} – {fmtTime(booking.ends_at, tz)} {tzLabel(tz, new Date(booking.starts_at))}</span>
        </p>
        {booking.meeting_link && !cancelled && (
          <p className="flex items-center gap-2"><Video size={15} /><a href={booking.meeting_link} className="text-[#1a3a5c] underline break-all" data-testid="booking-meet-link">{booking.meeting_link}</a></p>
        )}
      </div>
      {!cancelled && (
        <div className="flex flex-wrap justify-center gap-3 text-sm">
          <a href={`${API}/public/booking/${booking.manage_token}/ics`} className="inline-flex items-center gap-1 text-[#1a3a5c] underline" data-testid="booking-ics-link"><Download size={14} /> Add to calendar (.ics)</a>
          {!manage && <a href={`/booking/${booking.manage_token}`} className="text-[#1a3a5c] underline" data-testid="booking-manage-link">Reschedule or cancel</a>}
        </div>
      )}
      {!cancelled && !manage && <p className="text-xs text-slate-500">A confirmation email with these details is on its way.</p>}
      {children}
    </div>
  );
};
